// extracted by mini-css-extract-plugin
module.exports = {"podcastCard":"PodcastNavigator_podcastCard__K3zgM"};